<template>
	<div>
    <Disclosure v-slot="{ open }">
        <DisclosureButton :class="[open ? '' : '', 'w-full flex p-5 text-left group']">
            <div class="flex space-x-4 items-center justify-between w-full relative">
	        	<div class="absolute -left-1">
	        		<svg v-if="!open" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
	        		<svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
	        	</div>
                <div class="flex space-x-4 items-center flex-grow -translate-x-4 group-hover:translate-x-3 transition-transform duration-150 ease-in-out">
                    <div class="">
                        <div class="shrink-0 h-16 w-16 bg-cover bg-center rounded-lg bg-gray-300" :style="'background-image: url(' + podcast.image + ')'" />
                    </div>
                    <div>
                        <div class="text-2xl font-semibold tracking-tight">{{ podcast?.title }}</div>
                        <div class="text-gray-700 text-xs font-medium mt-1">
                            {{ podcast?.episodeCount }} 
                            <span v-if="podcast?.episodes.data.length">· {{ podcast?.lastUpdated }}</span>
                        </div>
                    </div>
                </div>
                <div class="flex space-x-4">
                    <div class="w-24">
                        <div class="text-2xl font-semibold">{{ podcast?.starts }}</div>
                        <div class="text-gray-700 text-xs font-medium mt-1">Starts</div>
                    </div>
                    <div class="w-24">
                        <div class="text-2xl font-semibold">{{ podcast?.streams }}</div>
                        <div class="text-gray-700 text-xs font-medium mt-1">Streams</div>
                    </div>
                    <div class="w-20">
                        <div class="text-2xl font-semibold">{{ podcast?.completion }}%</div>
                        <div class="text-gray-700 text-xs font-medium mt-1">Completion</div>
                    </div>
                </div>

                <Menu as="div" class="relative" v-slot="{ open }">
                	<div>
                		<MenuButton @click.prevent="" class="focus:outline-none focus:ring-0 focus:ring-regal-blue-700 focus:ring-offset-0">
			                <div :class="[open ? 'bg-gray-200' : '' ,'w-10 h-10 rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-200 cursor-pointer']">
			                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
			                </div>
                		</MenuButton>
                	</div>

                	<transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                		<MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                			<div class="py-1">
                				<MenuItem v-slot="{ active, close }">
                					<div preserve-state @click.prevent="editingActive = true; close()" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2.5 text-sm flex space-x-2.5 font-medium']">
	                					<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
	                					<div>Edit</div>
                					</div>
                				</MenuItem>
                		</div>
                		<div class="py-1">
	                		<MenuItem v-slot="{ active, close }">
	                			<Link :href="route('episodes.create', podcast.uuid)" @click="close" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2.5 text-sm flex space-x-2.5 font-medium w-full cursor-pointer']">
	                				<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
	                				<div>Add episode</div>
	                			</Link>
	                		</MenuItem>
                		</div>
                		<div class="py-1">
	                		<MenuItem v-slot="{ active, close }">
	                			<Link :href="route('podcasts.destroy', podcast)" method="delete" as="button" @click="close" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2.5 text-sm flex space-x-2.5 font-medium w-full cursor-pointer']">
	                				<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
	                				<div>Delete</div>
	                			</Link>
	                		</MenuItem>
                		</div>
                </MenuItems>
            </transition>
        </Menu>


            </div>
            
        </DisclosureButton>
        <DisclosurePanel class="">
            <div class="bg-white rounded-b-2xl p-3 pt-0 pl-10">
                <template v-for="(episode, index) in podcast.episodes.data">
                    <Link :href="route('episodes.edit', episode.uuid)" class="flex justify-between items-center text-left space-x-4 hover:bg-gray-200 rounded-xl p-2 cursor-pointer group relative">
                        <div>
                            <div class="">
                                <div class="shrink-0 h-16 w-16 bg-cover bg-center rounded-lg bg-gray-300" :style="'background-image: url(' + episode.image + ')'" />
                            </div>
                        </div>
                        <div class="flex-grow flex space-x-4 items-center">
                            <div class="w-48">
                                <div class="font-semibold truncate">
                                    {{ episode?.title }}
                                </div>
                                <div class="text-gray-700 text-xs font-medium truncate">{{ episode?.publishedAt }}</div>
                            </div>
                            <div>
                                <div class="flex space-x-1.5 items-center pr-8">
                                    <div class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="{ 'bg-green-100 text-green-800': episode.status == 'Published', 'bg-yellow-100 text-yellow-800': episode.status == 'Scheduled', 'bg-gray-600 text-white': episode.status == 'Processing'}">
                                        {{ episode?.status }}
                                    </div>
                                    <div v-if="episode?.shared" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-300">
                                        Shared
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex space-x-4 text-sm text-gray-700 font-medium pr-10">
                            <div class="w-24">
                                <div class="">{{ episode?.starts }}</div>
                            </div>
                            <div class="w-24">
                                <div class="">{{ episode?.streams }}</div>
                            </div>
                            <div class="w-24">
                                <div class="">{{ episode?.completion }}%</div>
                            </div>
                        </div>
                    </Link>
                </template>
            </div>
        </DisclosurePanel>
    </Disclosure>
</div>

    <Modal v-model:open="editingActive">
        <PodcastForm :categories="categories" v-model:open="editingActive" :podcast="podcast"/>
    </Modal>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import Modal from '@/Shared/Modal'
import PodcastForm from '@/Shared/PodcastForm'
import {
Disclosure, DisclosureButton, DisclosurePanel,
Menu, MenuButton, MenuItem, MenuItems
} from '@headlessui/vue'

const props = defineProps(['podcast', 'categories'])
const editingActive = ref(false)
</script>
